/**
 * Rewrites same-site links to plain collection pages so they already carry
 * filter.v.availability=1 before the browser navigates, instead of letting
 * the collection page load and then issue a second, bfcache-breaking
 * location.replace() redirect (see layout/theme.liquid).
 */
(function () {
	function stockPrefKey(pathname) {
		return 'stockPref:' + pathname;
	}

	document.addEventListener(
		'click',
		function (event) {
			var anchor = event.target.closest('a[href]');
			if (!anchor) return;
			if (anchor.closest('.active-facets, .facets')) return;

			var url;
			try {
				url = new URL(anchor.href, window.location.origin);
			} catch (e) {
				return;
			}
			if (url.origin !== window.location.origin) return;
			if (!/^\/collections\/[^/]+\/?$/.test(url.pathname)) return;
			if (url.searchParams.has('filter.v.availability')) return;

			var pref = null;
			try {
				pref = sessionStorage.getItem(stockPrefKey(url.pathname));
			} catch (e) {}
			if (pref === 'all') return;

			url.searchParams.set('filter.v.availability', '1');
			try {
				sessionStorage.setItem(stockPrefKey(url.pathname), '1');
			} catch (e) {}
			anchor.href = url.pathname + '?' + url.searchParams.toString() + url.hash;
		},
		true
	);
})();
